import ButtonConfig from './ButtonConfig'

export default ButtonConfig
